import { render, staticRenderFns } from "./BnOffsetCardSmall.vue?vue&type=template&id=180066a9&scoped=true&"
import script from "./BnOffsetCardSmall.vue?vue&type=script&lang=js&"
export * from "./BnOffsetCardSmall.vue?vue&type=script&lang=js&"
import style0 from "./BnOffsetCardSmall.vue?vue&type=style&index=0&id=180066a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180066a9",
  null
  
)

export default component.exports